








































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractDocumentsEdoByContract } from "@/models/contract";
import Page from "@/components/for-page-grid/Page.vue";
import ContractDocumentEdoTable from "@/components/for-documents-view/ContractDocumentEdoTable.vue";
import ContractDocGetterDialog from "@/components/for-documents-view/ContractDocGetterDialog.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import { mapGetters } from "vuex";
import DocGetterMixin from "@/components/mixins/DocGetter.vue";
import XDialog from "@/components/SimpleDialog.vue";

@Component({
  components: {
    Page,
    ContractDocumentEdoTable,
    ContractDocGetterDialog,
    XNotice,
    XDialog,
  },
  computed: {
    ...mapGetters("contract", { contractId: "id" })
  },
})
class ContractEdoDocuments extends Mixins(AppApiMixin, DocGetterMixin) {
  documentList: ContractDocumentsEdoByContract[] = [];
  currentDocId = -1;
  currentDocName = '';
  currentDocStatus = -1;

  // Состояния всплывающих элементов страницы.
  showDocSendingDialog = false;
  useDocSendingDialogNotice = false;
  showDocSubscribeDialogNotice = false;
  targetEmail = "";

  showDocDownloadingDialog = false;

  declineDialog = false;
  declineDialogMessage = "";

  public mounted() {
    this.getDocData();
  }

  public getDocData() {
    this.getContractDocumentsEdoByContract(
      (documentList: ContractDocumentsEdoByContract[]) => {
        this.documentList = documentList;
      }
    );
  }

  public closeAllDialogs() {
    this.showDocSendingDialog = false;
    this.showDocDownloadingDialog = false;
    this.showDocSubscribeDialogNotice = false;

    this.targetEmail = "";
    this.currentDocId = -1;
    this.currentDocName = "";

    this.currentDocStatus = -1;
    this.declineDialog = false;
    this.declineDialogMessage = "";
  }

  public getDocName() {
    return this.documentList.find((doc) => {
      return doc.$номерЗаписи === this.currentDocId;
    })?.["тип документа"] || '';
  }

  public setDocStatus() {
    this.setContractEdoDocumentStatus({
      documentId: this.currentDocId,
      status: this.currentDocStatus,
      message: this.declineDialogMessage,
    })
      .then((response) => {
        if (response) {
          this.showDocSubscribeDialogNotice = true;
          this.getDocData();
        }
      })
      .catch((_) => {
        this.setErrorMessage(_ || 'Ошибка установления статуса документа')
      });
  }
}

export default ContractEdoDocuments;
